import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/hooks/useAuth";

export const DEFAULTS = { company_name: "Touba Tissu", phone: "", address: "", email: "", extra_info: "", footer: "Copyright IBM · 77 571 93 98", color_primary: "#14b8a6", color_transfers: "#2563eb", color_reports: "#059669", payment_methods: ["ESPECE", "WAVE", "Orange Money"], receipt_message: "Merci de votre visite !", currency: "FCFA", logo_v: null };

const Ctx = createContext({ settings: DEFAULTS, logoV: null, refresh: () => {} });

const shade = (hex, f) => { if (!/^#[0-9a-fA-F]{6}$/.test(hex || "")) return "rgb(0,0,0)"; const n = parseInt(hex.slice(1), 16); const r = Math.max(0, ((n >> 16) & 255) * f), g = Math.max(0, ((n >> 8) & 255) * f), b = Math.max(0, (n & 255) * f); return `rgb(${r | 0},${g | 0},${b | 0})`; };

export function SettingsProvider({ children }) {
  const { user } = useAuth();
  const [settings, setSettings] = useState(DEFAULTS);
  const refresh = useCallback(() => { api.get("/settings").then((r) => setSettings({ ...DEFAULTS, ...r.data })).catch(() => {}); }, []);
  useEffect(() => { if (user) refresh(); }, [user, refresh]);
  useEffect(() => {
    const r = document.documentElement.style;
    const cp = settings.color_primary || DEFAULTS.color_primary, ct = settings.color_transfers || DEFAULTS.color_transfers, cr = settings.color_reports || DEFAULTS.color_reports;
    r.setProperty("--brand", cp); r.setProperty("--brand-dark", shade(cp, 0.85));
    r.setProperty("--c-transfers", ct); r.setProperty("--c-transfers-dark", shade(ct, 0.85));
    r.setProperty("--c-reports", cr); r.setProperty("--c-reports-dark", shade(cr, 0.85));
    document.title = settings.company_name || DEFAULTS.company_name;
  }, [settings]);
  return <Ctx.Provider value={{ settings, logoV: settings.logo_v, refresh }}>{children}</Ctx.Provider>;
}

export const useSettings = () => useContext(Ctx);
